export default __webpack_public_path__ + "static/media/531.003372d5.png";